import gamePole from '../images/gamepole.png'
import cres1 from '../images/cres1.png'
import cres2 from '../images/cres2.png'
import {gql, useQuery} from '@apollo/client'
import {useEffect, useState} from 'react'
import CardMap from '../components/CardMap'

const MAIN_QUERY = gql`
    query MyQuery {
        page(id: "5", idType: DATABASE_ID) {
            title
            mainSettingss {
                etap
            }
        },
        players(first: 100) {
            nodes {
                title
                id
                content
                players {
                    age
                    agecart
                    bestplayer
                    club
                    fieldGroupName
                    lastname
                    numberplayer
                    positionreiting
                    positionmap
                    position
                    iconfootbool {
                        sourceUrl
                    }
                    avatar {
                        sourceUrl
                    }
                    avatar1 {
                        sourceUrl
                    }
                }
            }
        }}`


const gamePositions = [
  'V',
  'CZP',
  'CZL',
  'LZ',
  'PZ',
  'OP',
  'CPL',
  'CPR',
  'PP',
  'LP',
  'N',
]


const Home = () => {
  const {loading, data} = useQuery(MAIN_QUERY)
  const [players, setPlayers] = useState([])

  useEffect(() => {
    if (!loading) {
      const state = Number(data.page?.mainSettingss?.etap)
      const players = data.players.nodes
      const game = gamePositions.map(pos => {
        if (state === 1) {
          return {
            pos,
            players: ['V', 'CZP', 'CZL', 'LZ', 'PZ'].includes(pos) ? players.filter(player => player.players.positionmap === pos) : null,
          }
        }
        if (state === 2) {
          return {
            pos,
            players: ['V', 'CZP', 'CZL', 'LZ', 'PZ', 'OP', 'CPR', 'CPL'].includes(pos) ? players.filter(player => player.players.positionmap === pos) : null,
          }
        }


        if (state === 3) {
          return {
            pos,
            players: ['V', 'CZP', 'CZL', 'LZ', 'PZ', 'OP', 'CPR', 'CPL', 'N', 'LP', 'PP'].includes(pos) ? players.filter(player => player.players.positionmap === pos) : null,
          }
        }

        return {
          pos,
          players,
        }
      })
      setPlayers(game)
    }
  }, [data, loading])

  return (
    <div>
      <div className="content">
        <h1 className="title-main">
          <span>топ-55</span> <br/>
          самых талантливых <br/>
          футболистов России
        </h1>
        <div className="text-main">
          <p> В феврале известное на весь мир французское издание L’Equipe составило список из 50 самых одаренных
            игроков планеты, родившихся после 1 января 2001-го. В нем не оказалось ни одного российского футболиста. Мы
            решили, что это несправедливо, и сделали свой рейтинг, в который вошли 55 российских талантов – по пять на
            каждую позицию. Список составлен с помощью тренеров и функционеров, работающих в детско-юношеском футболе.
            Критерий у списка только один: игрок рожден 1 января 2001 года или позже. При этом он может быть футболистом
            любого российского или зарубежного клуба.
          </p>
        </div>


        <div className="game">

          <img src={cres1} alt="" className="cres1"/>
          <img src={cres2} alt="" className="cres2"/>
          <img src={cres1} alt="" className="cres3"/>
          <div className="game-cards">
            {loading ? '' : players.length && players.map((game, index) => <CardMap game={game} key={index}/>)}
          </div>
          <img src={gamePole} alt="" className="playingField"/>
        </div>
      </div>
    </div>
  )
}

export default Home
